import { styled } from '@mui/material'

export const Container = styled('div')(() => ({
  position: 'fixed',
  zIndex: 9999,
  inset: 0,
  backgroundColor: '#00000069',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const components = { Container }

export default components
